/* eslint-disable */
import Vue from "vue";

Vue.config.productionTip = false;
export const productDetailsBus = new Vue();

export const productionBus = new Vue();



// WEBPACK FOOTER //
// ./src/helpers/buses.js